"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = crossReference;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _pulseCookie = require("./pulse-cookie");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-env browser */function crossReference(urls) {
  if ((0, _isArray["default"])(urls) && urls.length > 0) {
    var url = urls[0];
    return fetch("https://".concat(url, "/api/v1/pulse"), {
      method: 'GET',
      credentials: 'include'
    }).then(function (result) {
      return result.json();
    }) // New promise
    .then(function (response) {
      var _ref = response || {},
        pulse2data = _ref.pulse2data;
      if (pulse2data) {
        try {
          var serverData = (0, _pulseCookie.parsePulseCookies)(pulse2data);
          if (serverData.environmentId) {
            var _parsePulseCookies = (0, _pulseCookie.parsePulseCookies)(),
              environmentId = _parsePulseCookies.environmentId;
            (0, _pulseCookie.cacheOldEnvironmentId)(environmentId);
            (0, _pulseCookie.serializePulseCookie)(serverData);
            return Promise.resolve(pulse2data);
          }
          return crossReference(urls.slice(1));
        } catch (e) {
          return crossReference(urls.slice(1));
        }
      }
      return crossReference(urls.slice(1));
    })["catch"](function () {
      return crossReference(urls.slice(1));
    });
  }
  return Promise.resolve();
}